import { useMutation } from 'react-fetching-library';

const submitFormAction = ({ accountId, formValues }) => ({
  method: 'POST',
  endpoint: `/api/donate/accounts/${accountId}/perpetual-mass-offerings`,
  body: formValues,
});

export const useSubmitPerpetualMasses = () => {
  const { loading, payload, mutate, error, errorObject } = useMutation(submitFormAction);

  return { loading, payload, mutate, error, errorObject };
};
